@if (saveSuccess) {
    <div
        class="d-flex flex-row button-container align-items-center justify-content-between saved-state"
    >
        <span class="button-label">{{
            saveSuccessText ?? ('effSaveButton.saved' | t)
        }}</span>
        <eff-icon icon="done"></eff-icon>
    </div>
} @else {
    <div
        class="d-flex flex-row button-container align-items-center justify-content-center normal-state"
        ngClass="{ save-success: saveSuccess}"
    >
        <span class="button-label">{{ text ?? ('effSaveButton.save' | t) }}</span>
    </div>
}
